import { render, staticRenderFns } from "./CustomsInvoiceDetailsView.vue?vue&type=template&id=0a7ebe53&scoped=true&"
import script from "./CustomsInvoiceDetailsView.vue?vue&type=script&lang=ts&"
export * from "./CustomsInvoiceDetailsView.vue?vue&type=script&lang=ts&"
import style0 from "./CustomsInvoiceDetailsView.vue?vue&type=style&index=0&id=0a7ebe53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7ebe53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VIcon,VTooltip})
